import { Calculation, PaymentFrequency } from '@servicetitan/financing-api-client';
import { Payment } from './Payment';

interface StandardInstallmentProps {
    plan: Calculation;
    currentFrequency?: PaymentFrequency;
    placeholder?: boolean;
}

export const StandardInstallment = ({
    plan,
    currentFrequency,
    placeholder,
}: StandardInstallmentProps) => {
    return (
        <Payment
            plan={plan}
            eyebrowText="Min. Payment"
            currentFrequency={currentFrequency}
            placeholder={placeholder}
        />
    );
};
